export const Constants = {
    roles: [ 'documents', 'vouchers', 'chatconfig','license', 'adminconfig', 'integration', 'documentCategory', 'activityType', 'pdefinition', 'vpolicy', 'departments', 'workplace', 'planning', 'projects', 'staff', 'holidays','hcalendar', 'pdocuments','messages','news','daily','monthly','employee','procedures','customerSupport','calendar','complaint','complaintconfig','expensesheet','expensesheetcategory','emaillog', 'teams', 'profiles'],   
	formatters: [ 'formatCurrency', 'formatBoolean', 'formatDate', 'formatDateTime', 'formatDateTimeLocal','formatLongDateTime', 'formatSimpleDate', 'formatTime', 'formatChoice', 'formatDecimalNumber'],
    filterSources: ['text','date','select'],
    filterTypes: ['string','date','integer'],
    eventModes: ['CORE','EVENT','DIALOG','VUEDIALOG'],
    eventTypes: {
        'CORE':['EXPORT','LINK'],
        'EVENT':['WORKDAY','EMPLOYEE','ACTION','VACATION','REQUEST'],
        'DIALOG':['VOUCHER','CALENDAR','ACTIVITY_TYPE'],
        'VUEDIALOG':['AUDIT_LOG','MODULE','EXTERNAL_DOCUMENT_CATEGORY','SYS_CONFIG','SUPPORT_TICKET','EXPORT', 'MESSAGE', 'DOCUMENT_CATEGORY','COPY_CALENDAR_EXERCISE','COPY_CALENDAR_RULES','COMPLAINT','COMPLAINT_CONFIG','DIALOG_BUILDER','DIALOG_EDITOR','DEPARTMENT', 'WEBHOOKS', 'TELEWORK', 'ACTIVITY_TYPE', 'EXPENSE_SHEET_CATEGORY', 'EXPENSE_SHEET', 'EXPENSE_SHEET_ITEM', 'WORKPLACE', 'HOLIDAYS', 'CREATE_TEAM', 'EDIT_TEAM', 'CREATE_PROJECT', 'EDIT_PROJECT', 'RELEASE', 'RESPONSE_MESSAGE', 'PROFILES', 'PARTNERS', 'NEWS','AI_ASSISTANT_LOG'],
    },
    eventActions: ['CREATE','EDIT','EDIT_ADMIN','XLS','DUPLICATE','PREVIEW','CSV','LINK','CALL_PHONE', 'SEND_EMAIL', 'SEND_MESSAGE', 'DELETE', 'OPEN_DIALOG', 'DOWNLOAD_XLSX_STAFF', 'DOWNLOAD_XLSX_ACTIVITIES', 'DOWNLOAD_XLSX_PROCEDURES', 'CREATE_EXERCISE'],
	
	MODULE_EXPENSE_SHEET_ITEM: 26,

	COLORS: [
		//
		{ id: "BLACK", name: "black", hex: "#000000" },
		{ id: "WHITE", name: "white", hex: "#FFFFFF" },
		//
		{ id: "BLUEGREY-LIGHTEN-5", name: "blue-grey lighten-5", hex: "#ECEFF1" },
		{ id: "BLUEGREY-LIGHTEN-4", name: "blue-grey lighten-4", hex: "#CFD8DC" },
		{ id: "BLUEGREY-LIGHTEN-3", name: "blue-grey lighten-3", hex: "#B0BEC5" },
		{ id: "BLUEGREY-LIGHTEN-2", name: "blue-grey lighten-2", hex: "#90A4AE" },
		{ id: "BLUEGREY-LIGHTEN-1", name: "blue-grey lighten-1", hex: "#78909C" },
		{ id: "BLUEGREY", name: "blue-grey", hex: "#607D8B" },
		{ id: "BLUEGREY-DARKEN-1", name: "blue-grey darken-1", hex: "#546E7A" },
		{ id: "BLUEGREY-DARKEN-2", name: "blue-grey darken-2", hex: "#455A64" },
		{ id: "BLUEGREY-DARKEN-3", name: "blue-grey darken-3", hex: "#37474F" },
		{ id: "BLUEGREY-DARKEN-4", name: "blue-grey darken-4", hex: "#263238" },
		//
		{ id: "GREY-LIGHTEN-5", name: "grey lighten-5", hex: "#FAFAFA" },
		{ id: "GREY-LIGHTEN-4", name: "grey lighten-4", hex: "#F5F5F5" },
		{ id: "GREY-LIGHTEN-3", name: "grey lighten-3", hex: "#EEEEEE" },
		{ id: "GREY-LIGHTEN-2", name: "grey lighten-2", hex: "#E0E0E0" },
		{ id: "GREY-LIGHTEN-1", name: "grey lighten-1", hex: "#BDBDBD" },
		{ id: "GREY", name: "grey", hex: "#9E9E9E" },
		{ id: "GREY-DARKEN-1", name: "grey darken-1", hex: "#757575" },
		{ id: "GREY-DARKEN-2", name: "grey darken-2", hex: "#616161" },
		{ id: "GREY-DARKEN-3", name: "grey darken-3", hex: "#424242" },
		{ id: "GREY-DARKEN-4", name: "grey darken-4", hex: "#212121" },
		//
		{ id: "BROWN-LIGHTEN-5", name: "brown lighten-5", hex: "#EFEBE9" },
		{ id: "BROWN-LIGHTEN-4", name: "brown lighten-4", hex: "#D7CCC8" },
		{ id: "BROWN-LIGHTEN-3", name: "brown lighten-3", hex: "#BCAAA4" },
		{ id: "BROWN-LIGHTEN-2", name: "brown lighten-2", hex: "#A1887F" },
		{ id: "BROWN-LIGHTEN-1", name: "brown lighten-1", hex: "#8D6E63" },
		{ id: "BROWN", name: "brown", hex: "#795548" },
		{ id: "BROWN-DARKEN-1", name: "brown darken-1", hex: "#6D4C41" },
		{ id: "BROWN-DARKEN-2", name: "brown darken-2", hex: "#5D4037" },
		{ id: "BROWN-DARKEN-3", name: "brown darken-3", hex: "#4E342E" },
		{ id: "BROWN-DARKEN-4", name: "brown darken-4", hex: "#3E2723" },
		//
		{ id: "DEEPORANGE-LIGHTEN-5", name: "deep-orange lighten-5", hex: "#FBE9E7" },
		{ id: "DEEPORANGE-LIGHTEN-4", name: "deep-orange lighten-4", hex: "#FFCCBC" },
		{ id: "DEEPORANGE-LIGHTEN-3", name: "deep-orange lighten-3", hex: "#FFAB91" },
		{ id: "DEEPORANGE-LIGHTEN-2", name: "deep-orange lighten-2", hex: "#FF8A65" },
		{ id: "DEEPORANGE-LIGHTEN-1", name: "deep-orange lighten-1", hex: "#FF7043" },
		{ id: "DEEPORANGE", name: "deep-orange", hex: "#FF5722" },
		{ id: "DEEPORANGE-DARKEN-1", name: "deep-orange darken-1", hex: "#F4511E" },
		{ id: "DEEPORANGE-DARKEN-2", name: "deep-orange darken-2", hex: "#E64A19" },
		{ id: "DEEPORANGE-DARKEN-3", name: "deep-orange darken-3", hex: "#D84315" },
		{ id: "DEEPORANGE-DARKEN-4", name: "deep-orange darken-4", hex: "#BF360C" },
		{ id: "DEEPORANGE-ACCENT-1", name: "deep-orange accent-1", hex: "#FF9E80" },
		{ id: "DEEPORANGE-ACCENT-2", name: "deep-orange accent-2", hex: "#FF6E40" },
		{ id: "DEEPORANGE-ACCENT-3", name: "deep-orange accent-3", hex: "#FF3D00" },
		{ id: "DEEPORANGE-ACCENT-4", name: "deep-orange accent-4", hex: "#DD2C00" },
		//
		{ id: "ORANGE-LIGHTEN-5", name: "orange lighten-5", hex: "#FFF3E0" },
		{ id: "ORANGE-LIGHTEN-4", name: "orange lighten-4", hex: "#FFE0B2" },
		{ id: "ORANGE-LIGHTEN-3", name: "orange lighten-3", hex: "#FFCC80" },
		{ id: "ORANGE-LIGHTEN-2", name: "orange lighten-2", hex: "#FFB74D" },
		{ id: "ORANGE-LIGHTEN-1", name: "orange lighten-1", hex: "#FFA726" },
		{ id: "ORANGE", name: "orange", hex: "#FF9800" },
		{ id: "ORANGE-DARKEN-1", name: "orange darken-1", hex: "#FB8C00" },
		{ id: "ORANGE-DARKEN-2", name: "orange darken-2", hex: "#F57C00" },
		{ id: "ORANGE-DARKEN-3", name: "orange darken-3", hex: "#EF6C00" },
		{ id: "ORANGE-DARKEN-4", name: "orange darken-4", hex: "#E65100" },
		{ id: "ORANGE-ACCENT-1", name: "orange accent-1", hex: "#FFD180" },
		{ id: "ORANGE-ACCENT-2", name: "orange accent-2", hex: "#FFAB40" },
		{ id: "ORANGE-ACCENT-3", name: "orange accent-3", hex: "#FF9100" },
		{ id: "ORANGE-ACCENT-4", name: "orange accent-4", hex: "#FF6D00" },
		//
		{ id: "AMBER-LIGHTEN-5", name: "amber lighten-5", hex: "#FFF8E1" },
		{ id: "AMBER-LIGHTEN-4", name: "amber lighten-4", hex: "#FFECB3" },
		{ id: "AMBER-LIGHTEN-3", name: "amber lighten-3", hex: "#FFE082" },
		{ id: "AMBER-LIGHTEN-2", name: "amber lighten-2", hex: "#FFD54F" },
		{ id: "AMBER-LIGHTEN-1", name: "amber lighten-1", hex: "#FFCA28" },
		{ id: "AMBER", name: "amber", hex: "#FFC107" },
		{ id: "AMBER-DARKEN-1", name: "amber darken-1", hex: "#FFB300" },
		{ id: "AMBER-DARKEN-2", name: "amber darken-2", hex: "#FFA000" },
		{ id: "AMBER-DARKEN-3", name: "amber darken-3", hex: "#FF8F00" },
		{ id: "AMBER-DARKEN-4", name: "amber darken-4", hex: "#FF6F00" },
		{ id: "AMBER-ACCENT-1", name: "amber accent-1", hex: "#FFE57F" },
		{ id: "AMBER-ACCENT-2", name: "amber accent-2", hex: "#FFD740" },
		{ id: "AMBER-ACCENT-3", name: "amber accent-3", hex: "#FFC400" },
		{ id: "AMBER-ACCENT-4", name: "amber accent-4", hex: "#FFAB00" },
		//
		{ id: "YELLOW-LIGHTEN-5", name: "yellow lighten-5", hex: "#FFFDE7" },
		{ id: "YELLOW-LIGHTEN-4", name: "yellow lighten-4", hex: "#FFF9C4" },
		{ id: "YELLOW-LIGHTEN-3", name: "yellow lighten-3", hex: "#FFF59D" },
		{ id: "YELLOW-LIGHTEN-2", name: "yellow lighten-2", hex: "#FFF176" },
		{ id: "YELLOW-LIGHTEN-1", name: "yellow lighten-1", hex: "#FFEE58" },
		{ id: "YELLOW", name: "yellow", hex: "#FFEB3B" },
		{ id: "YELLOW-DARKEN-1", name: "yellow darken-1", hex: "#FDD835" },
		{ id: "YELLOW-DARKEN-2", name: "yellow darken-2", hex: "#FBC02D" },
		{ id: "YELLOW-DARKEN-3", name: "yellow darken-3", hex: "#F9A825" },
		{ id: "YELLOW-DARKEN-4", name: "yellow darken-4", hex: "#F57F17" },
		{ id: "YELLOW-ACCENT-1", name: "yellow accent-1", hex: "#FFFF8D" },
		{ id: "YELLOW-ACCENT-2", name: "yellow accent-2", hex: "#FFFF00" },
		{ id: "YELLOW-ACCENT-3", name: "yellow accent-3", hex: "#FFEA00" },
		{ id: "YELLOW-ACCENT-4", name: "yellow accent-4", hex: "#FFD600" },
		//
		{ id: "LIME-LIGHTEN-5", name: "lime lighten-5", hex: "#F9FBE7" },
		{ id: "LIME-LIGHTEN-4", name: "lime lighten-4", hex: "#F0F4C3" },
		{ id: "LIME-LIGHTEN-3", name: "lime lighten-3", hex: "#E6EE9C" },
		{ id: "LIME-LIGHTEN-2", name: "lime lighten-2", hex: "#DCE775" },
		{ id: "LIME-LIGHTEN-1", name: "lime lighten-1", hex: "#D4E157" },
		{ id: "LIME", name: "lime", hex: "#CDDC39" },
		{ id: "LIME-DARKEN-1", name: "lime darken-1", hex: "#C0CA33" },
		{ id: "LIME-DARKEN-2", name: "lime darken-2", hex: "#AFB42B" },
		{ id: "LIME-DARKEN-3", name: "lime darken-3", hex: "#9E9D24" },
		{ id: "LIME-DARKEN-4", name: "lime darken-4", hex: "#827717" },
		{ id: "LIME-ACCENT-1", name: "lime accent-1", hex: "#F4FF81" },
		{ id: "LIME-ACCENT-2", name: "lime accent-2", hex: "#EEFF41" },
		{ id: "LIME-ACCENT-3", name: "lime accent-3", hex: "#C6FF00" },
		{ id: "LIME-ACCENT-4", name: "lime accent-4", hex: "#AEEA00" },
		//
		{ id: "LIGHTGREEN-LIGHTEN-5", name: "light-green lighten-5", hex: "#F1F8E9" },
		{ id: "LIGHTGREEN-LIGHTEN-4", name: "light-green lighten-4", hex: "#DCEDC8" },
		{ id: "LIGHTGREEN-LIGHTEN-3", name: "light-green lighten-3", hex: "#C5E1A5" },
		{ id: "LIGHTGREEN-LIGHTEN-2", name: "light-green lighten-2", hex: "#AED581" },
		{ id: "LIGHTGREEN-LIGHTEN-1", name: "light-green lighten-1", hex: "#9CCC65" },
		{ id: "LIGHTGREEN", name: "light-green", hex: "#8BC34A" },
		{ id: "LIGHTGREEN-DARKEN-1", name: "light-green darken-1", hex: "#7CB342" },
		{ id: "LIGHTGREEN-DARKEN-2", name: "light-green darken-2", hex: "#689F38" },
		{ id: "LIGHTGREEN-DARKEN-3", name: "light-green darken-3", hex: "#558B2F" },
		{ id: "LIGHTGREEN-DARKEN-4", name: "light-green darken-4", hex: "#33691E" },
		{ id: "LIGHTGREEN-ACCENT-1", name: "light-green accent-1", hex: "#CCFF90" },
		{ id: "LIGHTGREEN-ACCENT-2", name: "light-green accent-2", hex: "#B2FF59" },
		{ id: "LIGHTGREEN-ACCENT-3", name: "light-green accent-3", hex: "#76FF03" },
		{ id: "LIGHTGREEN-ACCENT-4", name: "light-green accent-4", hex: "#64DD17" },
		//
		{ id: "GREEN-LIGHTEN-5", name: "green lighten-5", hex: "#E8F5E9" },
		{ id: "GREEN-LIGHTEN-4", name: "green lighten-4", hex: "#C8E6C9" },
		{ id: "GREEN-LIGHTEN-3", name: "green lighten-3", hex: "#A5D6A7" },
		{ id: "GREEN-LIGHTEN-2", name: "green lighten-2", hex: "#81C784" },
		{ id: "GREEN-LIGHTEN-1", name: "green lighten-1", hex: "#66BB6A" },
		{ id: "GREEN", name: "green", hex: "#4CAF50" },
		{ id: "GREEN-DARKEN-1", name: "green darken-1", hex: "#43A047" },
		{ id: "GREEN-DARKEN-2", name: "green darken-2", hex: "#388E3C" },
		{ id: "GREEN-DARKEN-3", name: "green darken-3", hex: "#2E7D32" },
		{ id: "GREEN-DARKEN-4", name: "green darken-4", hex: "#1B5E20" },
		{ id: "GREEN-ACCENT-1", name: "green accent-1", hex: "#B9F6CA" },
		{ id: "GREEN-ACCENT-2", name: "green accent-2", hex: "#69F0AE" },
		{ id: "GREEN-ACCENT-3", name: "green accent-3", hex: "#00E676" },
		{ id: "GREEN-ACCENT-4", name: "green accent-4", hex: "#00C853" },
		//
		{ id: "TEAL-LIGHTEN-5", name: "teal lighten-5", hex: "#E0F2F1" },
		{ id: "TEAL-LIGHTEN-4", name: "teal lighten-4", hex: "#B2DFDB" },
		{ id: "TEAL-LIGHTEN-3", name: "teal lighten-3", hex: "#80CBC4" },
		{ id: "TEAL-LIGHTEN-2", name: "teal lighten-2", hex: "#4DB6AC" },
		{ id: "TEAL-LIGHTEN-1", name: "teal lighten-1", hex: "#26A69A" },
		{ id: "TEAL", name: "teal", hex: "#009688" },
		{ id: "TEAL-DARKEN-1", name: "teal darken-1", hex: "#00897B" },
		{ id: "TEAL-DARKEN-2", name: "teal darken-2", hex: "#00796B" },
		{ id: "TEAL-DARKEN-3", name: "teal darken-3", hex: "#00695C" },
		{ id: "TEAL-DARKEN-4", name: "teal darken-4", hex: "#004D40" },
		{ id: "TEAL-ACCENT-1", name: "teal accent-1", hex: "#A7FFEB" },
		{ id: "TEAL-ACCENT-2", name: "teal accent-2", hex: "#64FFDA" },
		{ id: "TEAL-ACCENT-3", name: "teal accent-3", hex: "#1DE9B6" },
		{ id: "TEAL-ACCENT-4", name: "teal accent-4", hex: "#00BFA5" },
		//
		{ id: "CYAN-LIGHTEN-5", name: "cyan lighten-5", hex: "#E0F7FA" },
		{ id: "CYAN-LIGHTEN-4", name: "cyan lighten-4", hex: "#B2EBF2" },
		{ id: "CYAN-LIGHTEN-3", name: "cyan lighten-3", hex: "#80DEEA" },
		{ id: "CYAN-LIGHTEN-2", name: "cyan lighten-2", hex: "#4DD0E1" },
		{ id: "CYAN-LIGHTEN-1", name: "cyan lighten-1", hex: "#26C6DA" },
		{ id: "CYAN", name: "cyan", hex: "#00BCD4" },
		{ id: "CYAN-DARKEN-1", name: "cyan darken-1", hex: "#00ACC1" },
		{ id: "CYAN-DARKEN-2", name: "cyan darken-2", hex: "#0097A7" },
		{ id: "CYAN-DARKEN-3", name: "cyan darken-3", hex: "#00838F" },
		{ id: "CYAN-DARKEN-4", name: "cyan darken-4", hex: "#006064" },
		{ id: "CYAN-ACCENT-1", name: "cyan accent-1", hex: "#84FFFF" },
		{ id: "CYAN-ACCENT-2", name: "cyan accent-2", hex: "#18FFFF" },
		{ id: "CYAN-ACCENT-3", name: "cyan accent-3", hex: "#00E5FF" },
		{ id: "CYAN-ACCENT-4", name: "cyan accent-4", hex: "#00B8D4" },
		//
		{ id: "LIGHTBLUE-LIGHTEN-5", name: "light-blue lighten-5", hex: "#E1F5FE" },
		{ id: "LIGHTBLUE-LIGHTEN-4", name: "light-blue lighten-4", hex: "#B3E5FC" },
		{ id: "LIGHTBLUE-LIGHTEN-3", name: "light-blue lighten-3", hex: "#81D4FA" },
		{ id: "LIGHTBLUE-LIGHTEN-2", name: "light-blue lighten-2", hex: "#4FC3F7" },
		{ id: "LIGHTBLUE-LIGHTEN-1", name: "light-blue lighten-1", hex: "#29B6F6" },
		{ id: "LIGHTBLUE", name: "light-blue", hex: "#03A9F4" },
		{ id: "LIGHTBLUE-DARKEN-1", name: "light-blue darken-1", hex: "#039BE5" },
		{ id: "LIGHTBLUE-DARKEN-2", name: "light-blue darken-2", hex: "#0288D1" },
		{ id: "LIGHTBLUE-DARKEN-3", name: "light-blue darken-3", hex: "#0277BD" },
		{ id: "LIGHTBLUE-DARKEN-4", name: "light-blue darken-4", hex: "#01579B" },
		{ id: "LIGHTBLUE-ACCENT-1", name: "light-blue accent-1", hex: "#80D8FF" },
		{ id: "LIGHTBLUE-ACCENT-2", name: "light-blue accent-2", hex: "#40C4FF" },
		{ id: "LIGHTBLUE-ACCENT-3", name: "light-blue accent-3", hex: "#00B0FF" },
		{ id: "LIGHTBLUE-ACCENT-4", name: "light-blue accent-4", hex: "#0091EA" },
		//
		{ id: "BLUE-LIGHTEN-5", name: "blue lighten-5", hex: "#E3F2FD" },
		{ id: "BLUE-LIGHTEN-4", name: "blue lighten-4", hex: "#BBDEFB" },
		{ id: "BLUE-LIGHTEN-3", name: "blue lighten-3", hex: "#90CAF9" },
		{ id: "BLUE-LIGHTEN-2", name: "blue lighten-2", hex: "#64B5F6" },
		{ id: "BLUE-LIGHTEN-1", name: "blue lighten-1", hex: "#42A5F5" },
		{ id: "BLUE", name: "blue", hex: "#2196F3" },
		{ id: "BLUE-DARKEN-1", name: "blue darken-1", hex: "#1E88E5" },
		{ id: "BLUE-DARKEN-2", name: "blue darken-2", hex: "#1976D2" },
		{ id: "BLUE-DARKEN-3", name: "blue darken-3", hex: "#1565C0" },
		{ id: "BLUE-DARKEN-4", name: "blue darken-4", hex: "#0D47A1" },
		{ id: "BLUE-ACCENT-1", name: "blue accent-1", hex: "#82B1FF" },
		{ id: "BLUE-ACCENT-2", name: "blue accent-2", hex: "#448AFF" },
		{ id: "BLUE-ACCENT-3", name: "blue accent-3", hex: "#2979FF" },
		{ id: "BLUE-ACCENT-4", name: "blue accent-4", hex: "#2962FF" },
		//
		{ id: "INDIGO-LIGHTEN-5", name: "indigo lighten-5", hex: "#E8EAF6" },
		{ id: "INDIGO-LIGHTEN-4", name: "indigo lighten-4", hex: "#C5CAE9" },
		{ id: "INDIGO-LIGHTEN-3", name: "indigo lighten-3", hex: "#9FA8DA" },
		{ id: "INDIGO-LIGHTEN-2", name: "indigo lighten-2", hex: "#7986CB" },
		{ id: "INDIGO-LIGHTEN-1", name: "indigo lighten-1", hex: "#5C6BC0" },
		{ id: "INDIGO", name: "indigo", hex: "#3F51B5" },
		{ id: "INDIGO-DARKEN-1", name: "indigo darken-1", hex: "#3949AB" },
		{ id: "INDIGO-DARKEN-2", name: "indigo darken-2", hex: "#303F9F" },
		{ id: "INDIGO-DARKEN-3", name: "indigo darken-3", hex: "#283593" },
		{ id: "INDIGO-DARKEN-4", name: "indigo darken-4", hex: "#1A237E" },
		{ id: "INDIGO-ACCENT-1", name: "indigo accent-1", hex: "#8C9EFF" },
		{ id: "INDIGO-ACCENT-2", name: "indigo accent-2", hex: "#536DFE" },
		{ id: "INDIGO-ACCENT-3", name: "indigo accent-3", hex: "#3D5AFE" },
		{ id: "INDIGO-ACCENT-4", name: "indigo accent-4", hex: "#304FFE" },
		//
		{ id: "DEEPPURPLE-LIGHTEN-5", name: "deep-purple lighten-5", hex: "#EDE7F6" },
		{ id: "DEEPPURPLE-LIGHTEN-4", name: "deep-purple lighten-4", hex: "#D1C4E9" },
		{ id: "DEEPPURPLE-LIGHTEN-3", name: "deep-purple lighten-3", hex: "#B39DDB" },
		{ id: "DEEPPURPLE-LIGHTEN-2", name: "deep-purple lighten-2", hex: "#9575CD" },
		{ id: "DEEPPURPLE-LIGHTEN-1", name: "deep-purple lighten-1", hex: "#7E57C2" },
		{ id: "DEEPPURPLE", name: "deep-purple", hex: "#673AB7" },
		{ id: "DEEPPURPLE-DARKEN-1", name: "deep-purple darken-1", hex: "#5E35B1" },
		{ id: "DEEPPURPLE-DARKEN-2", name: "deep-purple darken-2", hex: "#512DA8" },
		{ id: "DEEPPURPLE-DARKEN-3", name: "deep-purple darken-3", hex: "#4527A0" },
		{ id: "DEEPPURPLE-DARKEN-4", name: "deep-purple darken-4", hex: "#311B92" },
		{ id: "DEEPPURPLE-ACCENT-1", name: "deep-purple accent-1", hex: "#B388FF" },
		{ id: "DEEPPURPLE-ACCENT-2", name: "deep-purple accent-2", hex: "#7C4DFF" },
		{ id: "DEEPPURPLE-ACCENT-3", name: "deep-purple accent-3", hex: "#651FFF" },
		{ id: "DEEPPURPLE-ACCENT-4", name: "deep-purple accent-4", hex: "#6200EA" },
		//
		{ id: "PURPLE-LIGHTEN-5", name: "purple lighten-5", hex: "#F3E5F5" },
		{ id: "PURPLE-LIGHTEN-4", name: "purple lighten-4", hex: "#E1BEE7" },
		{ id: "PURPLE-LIGHTEN-3", name: "purple lighten-3", hex: "#CE93D8" },
		{ id: "PURPLE-LIGHTEN-2", name: "purple lighten-2", hex: "#BA68C8" },
		{ id: "PURPLE-LIGHTEN-1", name: "purple lighten-1", hex: "#AB47BC" },
		{ id: "PURPLE", name: "purple", hex: "#9C27B0" },
		{ id: "PURPLE-DARKEN-1", name: "purple darken-1", hex: "#8E24AA" },
		{ id: "PURPLE-DARKEN-2", name: "purple darken-2", hex: "#7B1FA2" },
		{ id: "PURPLE-DARKEN-3", name: "purple darken-3", hex: "#6A1B9A" },
		{ id: "PURPLE-DARKEN-4", name: "purple darken-4", hex: "#4A148C" },
		{ id: "PURPLE-ACCENT-1", name: "purple accent-1", hex: "#EA80FC" },
		{ id: "PURPLE-ACCENT-2", name: "purple accent-2", hex: "#E040FB" },
		{ id: "PURPLE-ACCENT-3", name: "purple accent-3", hex: "#D500F9" },
		{ id: "PURPLE-ACCENT-4", name: "purple accent-4", hex: "#AA00FF" },
		//
		{ id: "PINK-LIGHTEN-5", name: "pink lighten-5", hex: "#FCE4EC" },
		{ id: "PINK-LIGHTEN-4", name: "pink lighten-4", hex: "#F8BBD0" },
		{ id: "PINK-LIGHTEN-3", name: "pink lighten-3", hex: "#F48FB1" },
		{ id: "PINK-LIGHTEN-2", name: "pink lighten-2", hex: "#F06292" },
		{ id: "PINK-LIGHTEN-1", name: "pink lighten-1", hex: "#EC407A" },
		{ id: "PINK", name: "pink", hex: "#E91E63" },
		{ id: "PINK-DARKEN-1", name: "pink darken-1", hex: "#D81B60" },
		{ id: "PINK-DARKEN-2", name: "pink darken-2", hex: "#C2185B" },
		{ id: "PINK-DARKEN-3", name: "pink darken-3", hex: "#AD1457" },
		{ id: "PINK-DARKEN-4", name: "pink darken-4", hex: "#880E4F" },
		{ id: "PINK-ACCENT-1", name: "pink accent-1", hex: "#FF80AB" },
		{ id: "PINK-ACCENT-2", name: "pink accent-2", hex: "#FF4081" },
		{ id: "PINK-ACCENT-3", name: "pink accent-3", hex: "#F50057" },
		{ id: "PINK-ACCENT-4", name: "pink accent-4", hex: "#C51162" },
		//
		{ id: "RED-LIGHTEN-5", name: "red lighten-5", hex: "#FFEBEE" },
		{ id: "RED-LIGHTEN-4", name: "red lighten-4", hex: "#FFCDD2" },
		{ id: "RED-LIGHTEN-3", name: "red lighten-3", hex: "#EF9A9A" },
		{ id: "RED-LIGHTEN-2", name: "red lighten-2", hex: "#E57373" },
		{ id: "RED-LIGHTEN-1", name: "red lighten-1", hex: "#EF5350" },
		{ id: "RED", name: "red", hex: "#F44336" },
		{ id: "RED-DARKEN-1", name: "red darken-1", hex: "#E53935" },
		{ id: "RED-DARKEN-2", name: "red darken-2", hex: "#D32F2F" },
		{ id: "RED-DARKEN-3", name: "red darken-3", hex: "#C62828" },
		{ id: "RED-DARKEN-4", name: "red darken-4", hex: "#B71C1C" },
		{ id: "RED-ACCENT-1", name: "red accent-1", hex: "#FF8A80" },
		{ id: "RED-ACCENT-2", name: "red accent-2", hex: "#FF5252" },
		{ id: "RED-ACCENT-3", name: "red accent-3", hex: "#FF1744" },
		{ id: "RED-ACCENT-4", name: "red accent-4", hex: "#D50000" },
	],
	
	//Tipos de calendario
	MONTHLYDAY_TYPE: 0,
	WEEKLYDAY_TYPE: 1,
	HOLLYDAY_TYPE: 2,		

	//Estados de las solicitudes
	REQUEST_PREPARING: -1,
	REQUEST_PENDING: 0,
	REQUEST_APPROVED: 1,
	REQUEST_DECLINED: 2,
	REQUEST_CANCELED: 3,
	REQUEST_PROCESSED: 4,

	//Tipos de vacaciones
	VACATION_LEGEND_TYPE_PENDING: 1,
	VACATION_LEGEND_TYPE_APPROVED: 2,
	VACATION_LEGEND_TYPE_VACATIONS: 3,
	VACATION_LEGEND_TYPE_PAID_ABSENCES: 4,
	VACATION_LEGEND_TYPE_UNPAID_ABSENCES: 5,
	VACATION_LEGEND_TYPE_OTHER_UNPAID_ABSENCES: 6, 

	//Estados de las solicitudes de vacaciones
	FILTER_VACATION_TYPE_PENDING: 1, // Solicitud de vacaciones pendiente
	FILTER_VACATION_TYPE_APPROVED: 2, // Solicitud de vacaciones aprobada
	FILTER_VACATION_TYPE_VACATIONS: 3, // Solicitud de vacaciones completada
	FILTER_VACATION_TYPE_PAID_ABSENCES: 4, // Ausencia retribuida
	FILTER_VACATION_TYPE_OTHER_UNPAID_ABSENCES: 5, // otras ausencia no retribuida
	FILTER_VACATION_TYPE_REST: 6, // Dia de calendario para descanso
	FILTER_VACATION_TYPE_HOLIDAY: 7, // Dia de calendario para festivo

	//IDs de las bolsas de horas
	HOURS_BAG_1_ID: 1,
	HOURS_BAG_2_ID: 2,
	HOURS_BAG_3_ID: 3,
	HOURS_BAG_4_ID: 4,
	HOURS_BAG_5_ID: 5,
	HOURS_BAG_VACATION_ID: 6,
	HOURS_BAG_EXTRA_ID: 7,

	//Tipos de jornada
	REGULAR_DAY: 0,
	REST_DAY: 1,
	NATIONAL_HOLIDAY: 2,
	LOCAL_HOLIDAY: 3,
	COMPANY_HOLIDAY: 4,


	//Tipos de registros de vacaciones
	VACATION_RECORD_TYPE_PERIOD_START_BALANCE: 0,
	VACATION_RECORD_TYPE_REGULARIZATION: 1,
	VACATION_RECORD_TYPE_WORK_ACCRUED: 2,
	VACATION_RECORD_TYPE_COMPLETE_DAY: 7,
	VACATION_RECORD_TYPE_FOR_HOURS: 8,

	//Tipos de planning
	SHIFT_PLANNER_BY_SECTIONS: 0,
	SHIFT_PLANNER_BY_DAYS: 1,


	////////////////////////////////////////////////////////////////////////////////
	//Constantes para las licencias	
	////////////////////////////////////////////////////////////////////////////////
	//License SKU
	ACTIVE_EMPLOYEES: 0,
	STORAGE_MB: 1,

	//Stock SKU
	SMS_SIGNATURE: 0,

	//License/Stock classes
	LICENSE_CLASS_BASE: "TYPE-BASE",
	LICENSE_CLASS_EXTENSION: "TYPE-EXTENSION",	

	//Order types	
	ORDER_TYPE_PLAN_UPGRADE: 0,
	ORDER_TYPE_ITEM_PURCHASE: 1,

	//License types	
	LICENSE_TYPE_FREE: 0,
	LICENSE_TYPE_BUSINESS: 1,
	LICENSE_TYPE_CORPORATE: 2,

	//License plans	
	LICENSE_PLAN_FREE: 0,
	LICENSE_PLAN_MONTHLY: 1,
	LICENSE_PLAN_ANNUAL: 2,

	//Action class
	ITEM_EMPLOYEES: 0,
	ITEM_STORAGE: 1,
	ITEM_SIGNATURES: 2,
	////////////////////////////////////////////////////////////////////////////////

	//Calendar modes
	CALENDAR_STANDARD_CHECKIN: 0,	
	CALENDAR_ASSISTED_CHECKING: 1,

	// Permisos de lectura
	DENY_ALL: 0,
	ALLOW_READ_ONLY: 1,
	ALLOW_READ_WRITE: 2,
}